exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-main.driver-fix-stacking .container[data-v-311ec9b8]{overflow-y:hidden;height:calc(100vh - 267px)}.sticky.driver-fix-stacking[data-v-311ec9b8]{position:absolute!important;bottom:0;z-index:100002!important}.driver-fix-stacking .buttons-audio[data-v-311ec9b8]{z-index:100004!important}", ""]);

// exports
